import React from "react";

export default function FireIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fillRule="evenodd" clipRule="evenodd">
            <title>Fire Icon</title>
            <path d="M8.625 0c.61 7.189-5.625 9.664-5.625 15.996 0 4.301 3.069 7.972 9 8.004 5.931.032 9-4.414 9-8.956 0-4.141-2.062-8.046-5.952-10.474.924 2.607-.306 4.988-1.501 5.808.07-3.337-1.125-8.289-4.922-10.378zm4.711 13c3.755 3.989 1.449 9-1.567 9-1.835 0-2.779-1.265-2.769-2.577.019-2.433 2.737-2.435 4.336-6.423z" />
        </svg>
    );
}
